import { httpsCallable } from 'firebase/functions';
import { functions } from '../constants/firebaseModular';
import { CreatePassagePatientPayload } from '../types/Patient/CreatePassagePatientPayload';
import { CreatePassagePatientResponse } from '../types/Patient/CreatePassagePatientResponse';
import * as Sentry from '@sentry/browser';
import { getPatientDoc } from './getPatientDoc';

export const createPassagePatient = async (payload: CreatePassagePatientPayload) => {
  // CHECK FOR NAV INFO OBJECT IN PATIENT DOC
  const patientDoc = await getPatientDoc(payload.uid);
  // IF IT EXISTS, DO NOTHING
  if (patientDoc && patientDoc.navObj) {
    return;
  } else {
    // IF NOT, CALL CLOUD FUNCTION TO SET INITIAL NAV OBJECT FOR A SELF-GUIDED PATIENT ON THIS USER
    const postToCloudFunction = httpsCallable(functions, 'createPassagePatient') as (
      // eslint-disable-next-line
      payload: CreatePassagePatientPayload,
    ) => Promise<CreatePassagePatientResponse>;

    postToCloudFunction(payload)
      .then(async (response) => {
        if (response.data.status === 'error') {
          alert(`Error setting navigation object:  ${response.data.message}`);
          return;
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        Sentry.captureException(error);
        console.error('Error calling cloud function', errorCode, errorMessage);
      });
  }
};
